import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaWallet,
} from "react-icons/fa";
import SideBar from "../../components/Sidebar";
import PGService from "../../services/PGService";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("p_order_id");
  const status = searchParams.get("status");
  const error = searchParams.get("error");

  const [loading, setLoading] = useState(true);
  const [txnData, setTxnData] = useState(null);

  useEffect(() => {
    if (orderId) {
      fetchTransactionStatus();
    } else {
      setLoading(false);
    }
  }, [orderId]);

  const fetchTransactionStatus = async () => {
    try {
      const result = await PGService.txnStatus(orderId);

      if (result.success && result.data && result.data.status === "SUCCESS") {
        setTxnData(result.data.data);
      } else {
        setTxnData(null);
      }
    } catch (err) {
      setTxnData(null);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusUI = () => {
    if (!orderId) {
      return {
        icon: <FaTimesCircle size={70} className="text-danger" />,
        title: "Invalid Request",
        message: "Order ID is missing.",
        color: "danger",
      };
    }

    if (error) {
      return {
        icon: <FaTimesCircle size={70} className="text-danger" />,
        title: "Payment Failed",
        message: error.replaceAll("_", " "),
        color: "danger",
      };
    }

    if (!loading && !txnData) {
      return {
        icon: <FaTimesCircle size={70} className="text-danger" />,
        title: "Transaction Not Found",
        message: "No transaction data found for this order.",
        color: "danger",
      };
    }

    switch (txnData?.status || status) {
      case "SUCCESS":
        return {
          icon: <FaCheckCircle size={70} className="text-success" />,
          title: "Payment Successful",
          message: `Your payment was successful. ₹${txnData?.amount} has been added to your wallet.`,
          color: "success",
        };

      case "FAILED":
        return {
          icon: <FaTimesCircle size={70} className="text-danger" />,
          title: "Payment Failed",
          message: "Transaction was unsuccessful.",
          color: "danger",
        };

      case "PENDING":
        return {
          icon: <FaClock size={70} className="text-warning" />,
          title: "Payment Pending",
          message: "Waiting for confirmation from payment gateway.",
          color: "warning",
        };

      default:
        return {
          icon: <FaTimesCircle size={70} className="text-danger" />,
          title: "Invalid Transaction",
          message: "Transaction details could not be verified.",
          color: "danger",
        };
    }
  };

  const statusUI = getStatusUI();

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        <SideBar />

        <div className="col-md-9">
          <div className="card  mb-3">
            <div className="card-body p-4">
              {loading ? (
                <div className="text-center py-5">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  ></div>
                </div>
              ) : (
                <>
                  <div className="text-center mb-4">
                    {statusUI.icon}

                    <h3 className={`mt-3 text-${statusUI.color}`}>
                      {statusUI.title}
                    </h3>

                    <p className="text-muted">{statusUI.message}</p>

                    {orderId && (
                      <p className="mb-0">
                        ORDER ID: <strong>{orderId}</strong>
                      </p>
                    )}
                  </div>

                  {txnData && (
                    <div className="border rounded p-3 bg-light">
                      <div className="row">
                        <div className="col-md-6 mb-2">
                          <strong>Amount</strong>
                        </div>
                        <div className="col-md-6 text-end">
                          <h5>₹{txnData.amount}</h5>
                        </div>

                        <div className="col-md-6 mb-2">
                          <strong>Status</strong>
                        </div>
                        <div className="col-md-6 text-end">
                          {txnData.status}
                        </div>

                        <div className="col-md-6 mb-2">
                          <strong>RRN</strong>
                        </div>
                        <div className="col-md-6 text-end">
                          {txnData.ref_id || "-"}
                        </div>

                        <div className="col-md-6 mb-2">
                          <strong>Date</strong>
                        </div>
                        <div className="col-md-6 text-end">
                          {txnData.timestamp}
                        </div>
                      </div>
                    </div>
                  )}

                  {error && (
                    <div className="alert alert-danger mt-3">
                      Error: {error.replaceAll("_", " ")}
                    </div>
                  )}

                  <div className="text-center mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/")}
                    >
                      <FaWallet className="me-2" />
                      Back To Home
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatus;
